import i18n from "@/i18n";
import {loginTokenSet} from "@/mixins/Auth";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";

export const ALLOWED_LOGIN_GROUP_TYPES = ['user', 'curator', 'director', 'manager'];

export const getLoginErrorMessage = (context) => {
    if (context && typeof context.$t === 'function') {
        return context.$t('error_msg2');
    }

    return i18n.t('error_msg2');
};

export const isAllowedLoginGroupType = (type) => {
    return ALLOWED_LOGIN_GROUP_TYPES.includes(type);
};

export const getLoginLevelObj = (g_idx, groupList) => {
    if (util.isEmpty(groupList)) {
        return null;
    }

    let groupIndex = groupList.findIndex(group => group.g_idx === g_idx);
    if (groupIndex < 0) {
        return null;
    }

    return {
        level: groupList[groupIndex].g_level,
        type: groupList[groupIndex].g_type,
        isSuper: groupList[groupIndex].g_is_super === 1,
    };
};

export const clearLoginState = (context) => {
    loginTokenSet('');

    if (context && context.$localStorage) {
        context.$localStorage.remove('token');
    }

    if (context && context.$store) {
        context.$store.dispatch('userInfo/initUserInfo', {data: {}});
    }

    EventBus.$emit('apiLoading', false);
};
